import * as providerActions from '@redux/modules/providerV4'

import usePaginatedLoader from './usePaginatedLoader'

function useProvidersV4(options = {}){
  const { searchFilter, selectedFlags } = options

  const { items: filteredProvidersV4, loading, hasMore, callbacks } = usePaginatedLoader({
    loadFn: providerActions.loadProvidersV4,
    entityKey: 'providersV4',
    queryOptions: {
      name: searchFilter || '',
      ...selectedFlags?.length && { flags: selectedFlags },
    },
  })

  return { filteredProvidersV4, loading, hasMore, callbacks }
}

export default useProvidersV4
